// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#footer[data-v-7f025344]{margin-top:20em}#footer a[data-v-7f025344]{font-weight:lighter;-webkit-text-decoration:none;text-decoration:none}#footer a[data-v-7f025344]:hover{-webkit-text-decoration:underline;text-decoration:underline}#footer .app-version[data-v-7f025344]{color:rgba(94,89,94,.55);font-size:.9em}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
